module.exports = __webpack_public_path__ + "static/img/new_hover.9ae1b203.svg";